import axiosConfig from '../../components/Conexion/AxiosConexionConfig';
import { apiUsuario } from '../../Config/const';

export class UsersService {
  async getUsers(loadPlantas, loadPlantaImagen) {
    const url = apiUsuario + '?filter=';
    const relacionPlantas = encodeURIComponent(
      JSON.stringify({
        include: [
          {
            relation: 'plantas',
            scope: {
              fields: [
                'idplanta',
                'nombre',
                'direccion',
                'pais',
                'tipo',
                'latitud',
                'longitud',
                'potenciapico',
                'probjetivo',
                'mwtotal',
                'idGpm',
              ],
            },
          },
        ],
      }),
    );
    try {
      const { data } = await axiosConfig.get(
        url + (loadPlantas ? relacionPlantas : ''),
      );
      return data;
    } catch (e) {
      console.error(e);
      throw new Error(e);
    }
  }

  async updateUser(user, includePlantas) {
    const url = apiUsuario + `/${user.idusuario}`;
    const updatedUserReq = {
      ...user,
      plantas: includePlantas ? user.plantas : undefined,
    };
    try {
      await axiosConfig.patch(url, updatedUserReq);
      return user;
    } catch (e) {
      throw new Error(e);
    }
  }

  async syncUsersWithAzure() {
    const url = '/updateusersazureddbb';
    try {
      const { data } = await axiosConfig.get(url);
      return data;
    } catch (e) {
      throw new Error(e);
    }
  }
}

export const usersService = new UsersService();
